import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-052",
  "use": "icon-052-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16\" fill=\"none\" id=\"icon-052\">\r\n  <path d=\"M1.49984 15.5C1.0396 15.5 0.666504 15.1269 0.666504 14.6667V1.33333C0.666504 0.8731 1.0396 0.5 1.49984 0.5H16.4998C16.9601 0.5 17.3332 0.8731 17.3332 1.33333V14.6667C17.3332 15.1269 16.9601 15.5 16.4998 15.5H1.49984ZM4.83317 6.33333H2.33317V13.8333H4.83317V6.33333ZM15.6665 6.33333H6.49984V13.8333H15.6665V6.33333ZM15.6665 2.16667H2.33317V4.66667H15.6665V2.16667Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol